import * as React from "react";
import Button from "../../components/button/button";
import "./404.scss";
const img404 = require("img/404.svg") as string;

class NotFound extends React.Component<{}, {}> {
  public render() {
    return (
      <div className="not-found">
        <Button
          extraClasses="btn--arrow-right"
          to="/"
          content="Back to Homepage"
        />
        <div className="not-found__image">
          <picture>
            <img src={img404} alt="Not Found" />
          </picture>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/404/404.tsx